import { ButtonBase, Grid } from '@mui/material';
import { memo, useCallback, useMemo } from 'react';
import ShaxmatkaHomeTooltip from '../tooltips/ShaxmatkaHomeTooltip';
import { Draggable, Droppable } from '@hello-pangea/dnd';
import { useShowroom } from 'context';

const Shaxmatka2Row = ({
  homesData,
  blockIndex,
  padezdIndex,
  padezd_id,
  block_id,
  floorNumber,
  isEditing,
  toggleSelectionItem = () => {},
  settingsMenuValue = '',
  maxPlace,
}) => {
  const [{ mode, freePlaceData, homeExpanded }, dispatch] = useShowroom();
  const isEditingPlace = mode == 'PLACE_EDIT';

  const homeList = useMemo(() => {
    const floorH = homesData?.filter((home) => home?.stage == floorNumber);

    function groupByAWithMissingIndexes(arr) {
      const groups = arr.reduce((acc, obj, i) => {
        const key = obj?.place ? obj.place - 1 : i;
        if (!acc[key]) acc[key] = [];
        acc[key].push(obj);
        return acc;
      }, {});

      const allKeys = Object.keys(groups).map(Number);
      const maxA = allKeys.length > 0 ? Math.max(...allKeys) : -1;

      const result = new Array(maxPlace).fill(null);
      for (let i = 0; i <= maxA; i++) {
        result[i] = groups[i];
      }

      return result;
    }
    const homes = groupByAWithMissingIndexes(floorH);

    const floorHomes = homes?.map((i, idx) =>
      i
        ? i
        : [
            {
              id: `placeholder-${blockIndex}-${padezdIndex}-${floorNumber}-${idx}`, // STABIL ID
              isFree: true,
              stage: floorNumber,
            },
          ],
    );

    const homesWithFreePlaces = [...homes, null]?.map((i, idx) =>
      i
        ? i
        : [
            {
              id: `placeholder-${blockIndex}-${padezdIndex}-${floorNumber}-${idx}`, // STABIL ID
              isFree: true,
              stage: floorNumber,
              place: idx + 1,
            },
          ],
    );
    return isEditingPlace ? homesWithFreePlaces : floorHomes;
  }, [
    blockIndex,
    floorNumber,
    homesData,
    maxPlace,
    padezdIndex,
    isEditingPlace,
  ]);

  // const grouped = Object.values(
  //   homesData?.reduce((acc, item) => {
  //     if (!acc[item.stage]) {
  //       acc[item.stage] = [];
  //     }

  //     acc[item.stage].push(item);
  //     return acc;
  //   }, {}),
  // );

  // const onClick = (item, index) => {
  //   if (floorNumber == 10) {
  //     grouped?.forEach((stages) => {
  //       const data = stages?.[index];
  //       if (data?.stage != 0)
  //         toggleSelectionItem(data.id, padezdIndex, blockIndex);
  //     });
  //   } else {
  //     toggleSelectionItem(item.id, padezdIndex, blockIndex);
  //   }
  // };

  const onClickFreePlace = (place, stage) => {
    if (mode != 'PLACE_EDIT') return;
    dispatch({
      type: 'setFreePlaceData',
      payload: { place, stage, block_id, padezd_id },
    });
    dispatch({ type: 'setHomeExpanded', payload: true });
  };

  const isSelectedPlace = useCallback(
    (place) => {
      if (!freePlaceData || mode != 'PLACE_EDIT' || !homeExpanded) return false;
      return (
        freePlaceData?.place == place &&
        freePlaceData?.stage == floorNumber &&
        freePlaceData?.block_id == block_id &&
        freePlaceData?.padezd_id == padezd_id
      );
    },
    [freePlaceData, floorNumber, block_id, padezd_id, homeExpanded],
  );

  return (
    <Droppable
      droppableId={`droppable-floor-${blockIndex}-${padezdIndex}-${floorNumber}`}
      direction='horizontal'
    >
      {(provided, snapshot) => (
        <Grid
          container
          rowSpacing={0}
          columns={{
            xs: parseInt(isEditingPlace ? maxPlace + 1 : maxPlace),
            sm: parseInt(isEditingPlace ? maxPlace + 1 : maxPlace),
          }}
          className={'sheet-home-row'}
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {padezdIndex == 0 && (
            <Grid item sm={1} xs={1} className='sheet-home-cell !-ml-2.5 !mr-0'>
              <ButtonBase
                className='sheet-home-row-floor h-full w-8 text-sm font-medium !cursor-default'
                disableRipple
              >
                {floorNumber}
              </ButtonBase>
            </Grid>
          )}

          {homeList?.length > 0
            ? homeList.map((cel, index) => {
                const keyBase = `block-${blockIndex}-${padezdIndex}-home`;
                return (
                  <div
                    className='flex flex-col gap-1'
                    key={`block-${blockIndex}-${padezdIndex}-home col ${index}`}
                  >
                    {cel?.map((item) => (
                      <Draggable
                        draggableId={`${item?.id}`}
                        index={index}
                        key={`${item?.id}`}
                        isDragDisabled={item?.isFree || mode != 'PLACE_EDIT'}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <Grid
                              item
                              sm={1}
                              xs={1}
                              className={`sheet-home-cell floor-${floorNumber} `}
                              id={`${keyBase}-${item.id}`}
                              key={`${keyBase}-${item.id}`}
                            >
                              {item?.isFree ? (
                                // <ButtonBase
                                //   className={`block-${blockIndex}-${padezdIndex}-home home-item status-null `}
                                // />
                                <div
                                  className={`block-${blockIndex}-${padezdIndex}-home home-item status-null hover:!bg-base-3 hover:text-white
                              ${isSelectedPlace(index + 1) ? '!border-solid !bg-blue-600 !opacity-100' : ''}
                              ${isEditingPlace ? 'cursor-pointer' : 'cursor-default'}`}
                                  onClick={() =>
                                    onClickFreePlace(item?.place, item?.stage)
                                  }
                                >
                                  {mode == 'PLACE_EDIT' && (
                                    <i className={`bi bi-plus-lg add-icon `} />
                                  )}
                                </div>
                              ) : (
                                <ShaxmatkaHomeTooltip
                                  home={item}
                                  disableFocusListener={isEditing}
                                  disableHoverListener={isEditing}
                                >
                                  <div
                                    className={`block-${blockIndex}-${padezdIndex}-home home-item status-${
                                      item?.contract?.status == 2
                                        ? 'completed'
                                        : item?.status
                                    }${item.disabled ? ' is-disabled' : ''} flex items-center justify-center ${mode == 'PLACE_EDIT' ? (snapshot?.isDragging ? 'cursor-grabbing' : 'cursor-grab') : 'cursor-pointer'}`}
                                    id={`home-${item.id}`}
                                    onClick={() => {
                                      if (!isEditingPlace) {
                                        // onClick(item, index)
                                        toggleSelectionItem(
                                          item.id,
                                          padezdIndex,
                                          blockIndex,
                                        );
                                      }
                                    }}
                                  >
                                    {settingsMenuValue === 'rooms' ? (
                                      !(
                                        item.stage && parseInt(item.stage) < 0
                                      ) ? (
                                        item.rooms ? (
                                          <div>{item.rooms}x</div>
                                        ) : (
                                          ''
                                        )
                                      ) : (
                                        <div>P</div>
                                      )
                                    ) : (
                                      <div>{item.number}</div>
                                    )}
                                  </div>
                                </ShaxmatkaHomeTooltip>
                              )}
                            </Grid>
                          </div>
                        )}
                      </Draggable>
                    ))}
                  </div>
                );
              })
            : [1].map((item) => (
                <Grid
                  item
                  sm={1}
                  xs={1}
                  key={`block-${blockIndex}-home-empty-${item}`}
                  id={`block-${blockIndex}-home-empty-${item}`}
                  className={`sheet-home-cell sheet-home-empty-cell floor-${floorNumber}`}
                >
                  <ButtonBase className='home-item is-empty'>
                    <div className='home-item-data'></div>
                  </ButtonBase>
                </Grid>
              ))}
          {provided.placeholder}
        </Grid>
      )}
    </Droppable>
  );
};

export default memo(Shaxmatka2Row);
